import React from "react";
import "./index.scss";

const Loader = () => {
  return (
    <div className="loader">
      <section>
        <div />
        <div />
        <div />
      </section>
    </div>
  );
};

export default Loader;
